import React from 'react'
import styled from 'styled-components'
import mailIcon from '../../images/mailbox.svg'
const MailWraper = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  a {
    display: flex;
    padding: 0 20px;
    border-right: 1px solid #fff;
  }
`

function Mail({ url }) {
  return (
    <MailWraper>
      <a href={url} target="_blank">
        <img width="20px" src={mailIcon} alt="企业邮局" />
      </a>
    </MailWraper>
  )
}

export default Mail
